import { AxiosResponse } from 'axios'
import SecureClient from '../SecureClient'

export default class EventsClient extends SecureClient {
	/**
	 * get all event ids
	 * @returns 
	 */
	public getEvents = (): Promise<AxiosResponse<string[]>> => {
		return this._api.get<string[]>(
			`Events`,
			{
				headers: {
					...this.authorizationHeader,
					...this.acceptHeader(),
					...this.contentTypeHeader(),
				},
			},
		)
	}
}
